var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGrowegy36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_1563_2615)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 17.284H26.68V26.5H23.992L23.656 24.796H23.44C23.008 25.276 22.256 25.724 21.184 26.14C20.128 26.54 18.888 26.74 17.464 26.74C14.6 26.74 12.344 25.972 10.696 24.436C9.048 22.884 8.224 20.86 8.224 18.364C8.224 15.772 9.12 13.644 10.912 11.98C12.704 10.3 15.056 9.46 17.968 9.46C20.384 9.46 22.344 9.988 23.848 11.044C25.368 12.1 26.256 13.42 26.512 15.004H22.72C22.432 14.252 21.872 13.668 21.04 13.252C20.224 12.82 19.2 12.604 17.968 12.604C16.016 12.604 14.488 13.14 13.384 14.212C12.28 15.268 11.728 16.652 11.728 18.364C11.728 19.98 12.24 21.276 13.264 22.252C14.288 23.228 15.776 23.716 17.728 23.716C19.392 23.716 20.736 23.436 21.76 22.876C22.784 22.316 23.296 21.524 23.296 20.5V19.924H17.92V17.284Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_2615",
    x1: 37.8,
    y1: -2.25,
    x2: 3.6,
    y2: 32.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B5CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrowegy36);
export default __webpack_public_path__ + "static/media/logo-growegy-36.677a9a5f3241d4de3bcd8cc18d080abf.svg";
export { ForwardRef as ReactComponent };